import {
    Component,
    Input
} from '@angular/core';

import { BriefingHeadingLevelEnum } from '../../../../Monitor/Briefings/enums/briefing-heading-level.enum';
import { MonitoringTextStyleModel } from '../../../../Monitor/Shared/models/monitoring-text-style.model';
import { BriefingTitleDisplayElementModel } from '../../../../Monitor/Briefings/models/briefing-title-display-element.model';

@Component({
    selector: 'agpr-title-display',
    templateUrl: './title-display.component.html',
    styleUrls: ['./title-display.component.scss'],
    standalone: false,
})
export class TitleDisplayComponent {
    @Input() set data(data: BriefingTitleDisplayElementModel) {
        this._data = data;
        if (this._data) {
            const headingLevel = (this._data as any).titleSettings.headingLevel || this._data.headingLevel;
            if ((headingLevel === BriefingHeadingLevelEnum.HEADING_3) && (this._data.styles?.headingThree)) {
                this.styles = this._data.styles.headingThree;
                this.headingLevel = 3;
            } else if ((headingLevel === BriefingHeadingLevelEnum.HEADING_2) && (this._data.styles?.headingTwo)) {
                this.styles = this._data.styles.headingTwo;
                this.headingLevel = 2;
            } else {
                this.styles = this._data.styles;
                this.headingLevel = 1;
            }
        }
    };

    _data: BriefingTitleDisplayElementModel;
    styles: MonitoringTextStyleModel;
    headingLevel: number;

    constructor() {}
}
